import { _values, tsValidateValue } from '@nu-art/ts-common';
import { DocumentReference_DocStatus } from './types.js';
export const DocumentReference_DocStatus_Options = _values(DocumentReference_DocStatus);
export const tsValidator_DocStatus_Options = tsValidateValue([...DocumentReference_DocStatus_Options]);
//# sourceMappingURL=consts.js.map